import { createSlice } from '@reduxjs/toolkit';
import { last } from 'GeminiViewerComponent/helpers/lodashUtils';
import { FormActions } from 'helpers/form-action';

const initialState = {
    openForm: null,
    isDirty: false,
    isEditingTag: false,
    formStack: [],
    currentForm: [],
    accountForm: {
        formKey: 'accountForm',
        isOpen: false,
        formAction: null,
        editObjectId: null,
        editObjectInfo: null,
        showGeminiViewer: false,
    },
    contentForm: {
        formKey: 'contentForm',
        isOpen: false,
        formAction: null,
        editObjectId: null,
        editObjectInfo: null,
        showGeminiViewer: true,
    },
    contentVersionForm: {
        formKey: 'contentVersionForm',
        isOpen: false,
        formAction: null,
        editObjectId: null,
        editObjectInfo: null,
        showGeminiViewer: false,
    },
    groupForm: {
        formKey: 'groupForm',
        isOpen: false,
        formAction: null,
        editObjectId: null,
        editObjectInfo: null,
        showGeminiViewer: false,
    },
    categoryForm: {
        formKey: 'categoryForm',
        isOpen: false,
        formAction: null,
        editObjectId: null,
        editObjectInfo: null,
        showGeminiViewer: false,
        assetTypeID: null,
    },
    hotspotForm: {
        formKey: 'hotspotForm',
        isOpen: false,
        formAction: null,
        editObjectId: null,
        editObjectInfo: null,
        showGeminiViewer: false,
    },
    itemForm: {
        formKey: 'itemForm',
        isOpen: false,
        formAction: null,
        editObjectId: null,
        editObjectInfo: null,
        showGeminiViewer: true,
        isContentPanelOpen: false,
    },
    linkForm: {
        formKey: 'linkForm',
        isOpen: false,
        formAction: null,
        editObjectId: null,
        editObjectInfo: null,
        showGeminiViewer: true,
    },
    assetForm: {
        formKey: 'assetForm',
        isOpen: false,
        formAction: null,
        editObjectId: null,
        editObjectInfo: null,
        showGeminiViewer: false,
        assetTypeID: null,
    },
    assetExportForm: {
        formKey: 'assetExportForm',
        isOpen: false,
        formAction: null,
        editObjectId: null,
        editObjectInfo: null,
        showGeminiViewer: false,
        assetTypeID: null,
    },
    procedureForm: {
        formKey: 'procedureForm',
        isOpen: false,
        formAction: null,
        editObjectId: null,
        editObjectInfo: null,
        showGeminiViewer: false,
        assetTypeID: null,
    },
    userForm: {
        formKey: 'userForm',
        isOpen: false,
        formAction: null,
        editObjectId: null,
        editObjectInfo: null,
        showGeminiViewer: false,
    },
    zoneForm: {
        formKey: 'zoneForm',
        isOpen: false,
        formAction: null,
        editObjectId: null,
        editObjectInfo: null,
        showGeminiViewer: true,
        isContentPanelOpen: false,
    },
    itemTagForm: {
        formKey: 'itemTagForm',
        isOpen: false,
        formAction: null,
        editObjectId: null,
        editObjectInfo: null,
        showGeminiViewer: false,
        assetTypeID: null,
    },
    clientForm: {
        formKey: 'clientForm',
        isOpen: false,
        formAction: null,
        editObjectId: null,
        editObjectInfo: null,
        showGeminiViewer: false,
        assetTypeID: null,
    },
    audienceForm: {
        formKey: 'audienceForm',
        isOpen: false,
        formAction: null,
        editObjectId: null,
        editObjectInfo: null,
        showGeminiViewer: false,
        assetTypeID: null,
    },
    toolCategoryForm: {
        formKey: 'toolCategoryForm',
        isOpen: false,
        formAction: null,
        editObjectId: null,
        editObjectInfo: null,
        showGeminiViewer: false,
        assetTypeID: null,
    },
    locationForm: {
        formKey: 'locationForm',
        isOpen: false,
        formAction: null,
        editObjectId: null,
        editObjectInfo: null,
        showGeminiViewer: false,
        assetTypeID: null,
    },
    toolForm: {
        formKey: 'toolForm',
        isOpen: false,
        formAction: null,
        editObjectId: null,
        editObjectInfo: null,
        showGeminiViewer: false,
        assetTypeID: null,
    },
    partForm: {
        formKey: 'partForm',
        isOpen: false,
        formAction: null,
        editObjectId: null,
        editObjectInfo: null,
        showGeminiViewer: false,
        assetTypeID: null,
    },
    partGroupForm: {
        formKey: 'partGroupForm',
        isOpen: false,
        formAction: null,
        editObjectId: null,
        editObjectInfo: null,
        showGeminiViewer: false,
        assetTypeID: null,
    },
    partCategoryForm: {
        formKey: 'partCategoryForm',
        isOpen: false,
        formAction: null,
        editObjectId: null,
        editObjectInfo: null,
        showGeminiViewer: false,
        assetTypeID: null,
    },
    companionForm: {
        formKey: 'companionForm',
        isOpen: false,
        formAction: null,
        editObjectId: null,
        editObjectInfo: null,
        showGeminiViewer: false,
    },
    newsFlashForm: {
        formKey: 'newsFlashForm',
        isOpen: false,
        formAction: null,
        editObjectId: null,
        editObjectInfo: null,
        showGeminiViewer: false,
    },
    managementDeployForm: {
        formKey: 'managementDeployForm',
        isOpen: false,
        formAction: null,
        editObjectId: null,
        editObjectInfo: null,
        showGeminiViewer: false,
    },
    contentInventoryForm: {
        formKey: 'contentInventoryForm',
        isOpen: false,
        formAction: null,
        editObjectId: null,
        editObjectInfo: null,
        showGeminiViewer: false,
    },
    exportAssetDetailsForm: {
        formKey: 'exportAssetDetailsForm',
        isOpen: false,
        formAction: null,
        editObjectId: null,
        editObjectInfo: null,
        showGeminiViewer: false,
    },
    jobDeployForm: {
        formKey: 'jobDeployForm',
        isOpen: false,
        formAction: null,
        editObjectId: null,
        editObjectInfo: null,
        showGeminiViewer: false,
    },
};

const formPanelSlice = createSlice({
    name: 'formPanel',
    initialState,
    reducers: {
        openPanel: (state, action) => {
            if (
                state[action.payload.formKey].isOpen !== true ||
                state[action.payload.formKey].formAction.id !== FormActions[action.payload.formAction].id
            ) {
                if (state[action.payload.formKey].isOpen) {
                    state.formStack.splice(state.formStack.indexOf(state[action.payload.formKey]), 1);
                    state.currentForm.splice(state.currentForm.indexOf(action.payload.formKey), 1);
                }
                state[action.payload.formKey].isOpen = true;
                state[action.payload.formKey].formAction = FormActions[action.payload.formAction];
                state[action.payload.formKey].assetTypeID = action.payload.assetTypeID;
                state[action.payload.formKey].isContentPanelOpen = action.payload.isContentPanelOpen ?? false;
                // Allow callers to supply editObject alongside openPanel so ContentForm
                // receives the correct props (e.g. linkTypeId) on its very first render,
                // avoiding a race where a subsequent setEditObject dispatch arrives too late.
                state[action.payload.formKey].editObjectInfo = action.payload.editObject ?? null;
                state.openForm = state[action.payload.formKey];
                state.formStack.push(state[action.payload.formKey]);
                state.currentForm.push(action.payload.formKey);
                state.isDirty = false;
                if (action.payload?.clearEditId) {
                    state[action.payload.formKey].editObjectId = null;
                }
            }
        },
        closePanel: (state, action) => {
            state[action.payload.formKey].isOpen = false;
            state[action.payload.formKey].formAction = null;
            state[action.payload.formKey].editObjectId = null;
            state[action.payload.formKey].editObjectInfo = null;
            state[action.payload.formKey].isContentPanelOpen = action.payload.isContentPanelOpen ?? false;
            state.openForm = null;
            state.formStack.splice(state.formStack.indexOf(state[action.payload.formKey]), 1);
            state.openForm = state.formStack.lengh > 0 ? last(state.formStack) : null;
            state.currentForm = state.currentForm.filter((formName) => formName !== action.payload.formKey);
            state.isDirty = false;
        },
        setEditObjectId: (state, action) => {
            state[action.payload.formKey].editObjectId = action.payload.object_id;
        },
        setEditObject: (state, action) => {
            state[action.payload.formKey].editObjectInfo = action.payload.editObject;
        },
        closeAllPanel: (state, action) => {
            return initialState;
        },
        setIsDirty: (state, action) => {
            state.isDirty = action.payload;
        },
        setIsEditingTag: (state, action) => {
            // NOTE: Set to true while inline tags are being
            // so the UI can adopt if needed. Currently the
            // UI is not depending on this.
            state.isEditingTag = action.payload;
        },
    },
    extraReducers: (builder) => {},
});

// Select all form info for rendering opened forms
export const selectFormInfo = (state) => state.forms;
export const currentFormInfo = (state) => state.forms.currentForm[state.forms.currentForm.length - 1];
export const selectIsFormOpen = (state) =>
    state.forms.accountForm.isOpen ||
    state.forms.contentForm.isOpen ||
    state.forms.contentVersionForm.isOpen ||
    state.forms.groupForm.isOpen ||
    state.forms.categoryForm.isOpen ||
    state.forms.hotspotForm.isOpen ||
    state.forms.itemForm.isOpen ||
    state.forms.linkForm.isOpen ||
    state.forms.assetForm.isOpen ||
    state.forms.procedureForm.isOpen ||
    state.forms.userForm.isOpen ||
    state.forms.itemTagForm.isOpen ||
    state.forms.clientForm.isOpen ||
    state.forms.audienceForm.isOpen ||
    state.forms.assetExportForm.isOpen ||
    state.forms.toolCategoryForm.isOpen ||
    state.forms.locationForm.isOpen ||
    state.forms.toolForm.isOpen ||
    state.forms.partForm.isOpen ||
    state.forms.partGroupForm.isOpen ||
    state.forms.partCategoryForm.isOpen ||
    state.forms.companionForm.isOpen ||
    state.forms.newsFlashForm.isOpen ||
    state.forms.zoneForm.isOpen ||
    state.forms.contentInventoryForm.isOpen ||
    state.forms.managementDeployForm.isOpen ||
    state.forms.exportAssetDetailsForm.isOpen;

export const getFormStack = (state) => state.forms.formStack;
export const selectDirtyFormFlag = (state) => state.forms.isDirty;
export const getIsEditingTag = (state) => state.forms.isEditingTag;

export const { openPanel, closePanel, setEditObjectId, setEditObject, closeAllPanel, setIsDirty, setIsEditingTag } =
    formPanelSlice.actions;

export default formPanelSlice.reducer;
